var map = {
	"./mobile/Pic_Banner_PA-01.png": 230,
	"./mobile/Pic_Banner_PA-01F.png": 186,
	"./mobile/Pic_Banner_PCB-01.png": 482,
	"./pc/Pic_Banner_PA-01.png": 700,
	"./pc/Pic_Banner_PA-01F.png": 546,
	"./pc/Pic_Banner_PCB-01.png": 309
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 453;